const clabeFormatter = (value) => (
  value ? value.toString().toUpperCase() : ''
);

export default clabeFormatter;
